export { default as OutfitCards } from './outfitCards'


// WEBPACK FOOTER //
// ./src/modules/outfits/outfitCards/index.js